export default "__VITE_ASSET__qhb65DLn__"